// NEW Store
import axios from "axios"

const state = {
  STATUS: null,
  screenInfo: {
    globeId: "",
    screeningID: "",
    scanId: "",
    scanDate: "",
    fullname: "",
    dob: "",
    age: "",
    email: "",
    cell: "",
    addressLn1: "",
    addressLn1: "",
    cityStateZip: ""
  },
  visionInfo: {
    acuityDist_OD: "",
    acuityDist_OS: "",
    acuityNear_OD: "",
    acuityNear_OS: "",
    autoRefOD_Sph: "",
    autoRefOD_Cyl: "",
    autoRefOD_Axi: "",
    autoRefOS_Sph: "",
    autoRefOS_Cyl: "",
    autoRefOS_Axi: "",
    eyePressure_OD: "",
    eyePressure_OS: "",
    correctedIOP_OD: "",
    correctedIOP_OS: "",
    angleMeasure_OD: "",
    angleMeasure_OS: ""
  },
  extPhoto: {
    title: "External Photo",
    imgUrl: "",
    diagOD: "",
    diagOS: ""
  },
  corPhoto: {
    title: "Wavefront Corneal Topgraphy",
    imgUrl_OD: "",
    imgUrl_OS: "",
    diagOD: "",
    diagOS: ""
  },
  pacPhoto: {
    title: "Anterior Segment OCT and Pachymetry",
    imgUrl_OD: "",
    imgUrl_OS: "",
    diagOD: "",
    diagOS: ""
  },
  opaPhoto: {
    title: "Lens Opacity / Cataract Grading",
    imgUrl: "",
    diagOD: "",
    diagOS: ""
  },
  funPhoto: {
    title: "Retina and Optic Nerve Photos",
    imgUrl_OD: "",
    imgUrl_OS: "",
    diagOD: "",
    diagOS: ""
  },
  macPhoto: {
    title: "Macula (OCT)",
    imgUrl_OD: "",
    imgUrl_OS: "",
    diagOD: "",
    diagOS: ""
  },
  nrvPhoto: {
    title: "Optic Nerve (OCT)",
    imgUrl_OD: "",
    imgUrl_OS: "",
    diagOD: "",
    diagOS: ""
  }
}

const getters = {
  preview: state => {
    return state
  }
}

// Called from Action to change State
const mutations = {
  mutatePreview(state, payload) {
    state[payload.property] = payload.with
  }
}

// Called externally to commit a State Mutation
const actions = {
  updatePreview({ state, commit }, payload) {
    commit("mutatePreview", {
      property: payload.stateProperty,
      with: payload.statePropertyValue
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
